// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M10.5 12H13.5V16H10.5V12Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M15.4142 1L21 6.58579V23H3V1H15.4142ZM14.5 7.5H19L14.5 3V7.5ZM10.5 10C9.39543 10 8.5 10.8954 8.5 12V16C8.5 17.1046 9.39543 18 10.5 18H13.5C14.6046 18 15.5 17.1046 15.5 16V12C15.5 10.8954 14.6046 10 13.5 10H10.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-file-outlook-filled')
export default class FileOutlookFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-outlook-filled',
    }
  }
}
